/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Awaiting_ReviewInputs */

const en_orders_review_awaiting_review = /** @type {(inputs: Orders_Review_Awaiting_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awaiting Review`)
};

const es_orders_review_awaiting_review = /** @type {(inputs: Orders_Review_Awaiting_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente de revision`)
};

/**
* | output |
* | --- |
* | "Awaiting Review" |
*
* @param {Orders_Review_Awaiting_ReviewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_awaiting_review = /** @type {((inputs?: Orders_Review_Awaiting_ReviewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Awaiting_ReviewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_awaiting_review(inputs)
	return es_orders_review_awaiting_review(inputs)
});